module.exports = __webpack_public_path__ + "assets/img/05b.c1dbd710.jpg";